export default "__VITE_ASSET__BVPrPkY9__"